export type SortBy =
  | 'visit_date'
  | 'patient_name'
  | 'clinic_name'
  | 'visit_type'
  | 'status'
  | 'assigned'
  | 'primary_diagnosis';

/**
 * Sort By
 */
/**
 * Array of all SortBy values.
 * Sort By
 */
export const SORTBY_VALUES: readonly SortBy[] = [
  'visit_date',
  'patient_name',
  'clinic_name',
  'visit_type',
  'status',
  'assigned',
  'primary_diagnosis',
] as const;
